import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../styles/sections.css';
import '../../styles/diagrams.css';

import sitemap from '../../assets/notify_sitemap.png';
import wireframe from '../../assets/notify_wireframe.png';
import logical from '../../assets/notify_logicaldiagram.png';

const Diagrams = () => {
  return (
          <section className="diagrams-section">
        <div className="section-header">
          <h2>DIAGRAMS</h2>
          <div className="underline"></div>
        </div>
        <div className="diagrams-content">
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={5000}
          showStatus={false}
          dynamicHeight={false}
        >
          <div>
            <img src={sitemap} alt="Sitemap Diagram" />
            <p className="legend">System Sitemap Diagram</p>
          </div>
          <div>
            <img src={wireframe} alt="Wireframe Diagram" />
            <p className="legend">Wireframe Diagram</p>
          </div>
          <div>
            <img src={logical} alt="Logical System Diagram" />
            <p className="legend">Logical Diagram</p>
          </div>
        </Carousel>
      </div>
    </section>
  );
};

export default Diagrams;
